<script setup>
import { MailOutlined } from '@ant-design/icons-vue';
import { onUnmounted, reactive, ref } from 'vue';

import { useStore } from './store';

const store = useStore();
const formRef = ref(null);
const formModel = store.$state;
const formRules = reactive({
  email: [{ required: true, message: 'Email é obrigatório' }],
});

onUnmounted(() =>
{
  store.$reset();
  store.$dispose();
});

async function esqueciSenha()
{
  await store.esqueciSenha();
}
</script>

<template>
  <a-layout class="esquecisenha-layout">
    <a-layout-content>
      <div class="esquecisenha-page">
        <a-card class="esquecisenha-card">
          <a-result
            v-if="store.status === 'success'"
            status="success"
            title="Um email foi enviado para você"
            sub-title="Acesse seu email e siga as instruções para resetar sua senha"
          >
            <template #extra>
              <a-button type="primary" @click="() => $router.push('/login')">
                Acesse o escritório
              </a-button>
            </template>
          </a-result>

          <a-alert
            v-if="store.status === 'error'"
            style="margin-bottom: 32px"
            :message="store.error"
            type="error"
          />

          <div v-if="store.status !== 'success'" class="form-container">
            <div class="logo-container">
              <img src="/images/logo-122x122.png">
            </div>

            <div style="text-align: center">
              <h2 class="titulo">
                Esqueceu sua senha?
              </h2>
            </div>

            <p class="subtitulo">
              Solicite uma nova senha para acessar o escritório
            </p>

            <a-form
              ref="formRef"
              layout="vertical"
              :model="formModel"
              :rules="formRules"
              :hide-required-mark="true"
              @finish="esqueciSenha"
            >
              <a-form-item
                label="Email"
                name="email"
                :wrapper-col="{ span: 24 }"
              >
                <a-input v-model:value="formModel.email" size="large">
                  <template #prefix>
                    <MailOutlined style="color: #d9d9d9" />
                  </template>
                </a-input>
              </a-form-item>
              <a-row>
                <a-col :span="24">
                  <a-button
                    :loading="store.status === 'loading'"
                    :block="true"
                    size="large"
                    type="primary"
                    html-type="submit"
                  >
                    Solicitar
                  </a-button>
                </a-col>
              </a-row>
            </a-form>
            <a-row style="margin-top: 24px" type="flex" justify="end">
              <a-col>
                <router-link to="/login">
                  Ir para login
                </router-link>
              </a-col>
            </a-row>
          </div>
        </a-card>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<style lang="less">
@import '../../../assets/styles/base.less';
.esquecisenha-layout {
  &.ant-layout {
    height: 100%;
  }
}

.esquecisenha-page {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  & .ant-alert-message {
    font-weight: 600;
  }

  & .esquecisenha-card.ant-card {
    padding-top: 48px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 56px;

    border: 0;
    width: 480px;
    // @media (min-width: @screen-md-min) {
    //   border: 1px solid #f0f0f0;
    //   width: 550px;
    // }

    & .ant-card-body {
      padding: 0;
    }

    & .logo-container {
      margin-bottom: 24px;
      text-align: center;
    }

    & .titulo {
      color: @logo-black;
      margin-bottom: 0;

      font-size: 30px;
      @media (min-width: @screen-md-min) {
        font-size: 36px;
      }
    }

    & .subtitulo {
      margin-bottom: 32px;
      text-align: center;
      font-size: 14px;
    }

    & label {
      font-size: 16px;
    }

    & .ant-input-affix-wrapper .ant-input-prefix {
      margin-right: 12px;
    }
  }
}
</style>
